/* globals jQuery, FWP */

jQuery(document).ready(function ($) {
	$('form[name="options"] label').each(function () {
		$(this).html($(this).attr('for'));
	});

	$('.proinput input[type="submit"]').attr('value', 'zoeken');

	$('.asp_main_container').each(function () {
		var id = $(this).attr('data-id');

		$(this)
			.find('.proinput .orig')
			.attr('id', 'orig' + id);
		$('<label for="orig' + id + '">Zoek</label>').insertAfter($(this).find('.orig'));

		$(this)
			.find('.proinput .autocomplete')
			.attr('id', 'autocomplete' + id);
		$('<label for="autocomplete' + id + '">Zoek</label>').insertAfter($(this).find('.autocomplete'));
	});

	var pageNumber = 1;

	$(document).on('facetwp-loaded', function () {
		var perPage = $('.facet-results').data('per-page');
		var focusPoint = pageNumber * perPage - perPage;

		pageNumber++;

		$('.facet-results .facetwp-template').children('div').eq(focusPoint).find('.link').focus();
		$('.facetwp-checkbox').attr({ role: 'checkbox', tabindex: '0' });
		$('.facetwp-checkbox:not(.checked)').attr('aria-checked', 'false');
		$('.facetwp-checkbox.checked').attr('aria-checked', 'true');

		$('.facetwp-checkbox').each(function () {
			if ($(this).find('label').length === 0) {
				$(this).wrapInner('<label></label>');
				$(this).find('label').attr('for', $(this).data('value'));
				$(this).prepend(
					'<input type="checkbox" id="' +
						$(this).data('value') +
						'" tabindex="-1" value="' +
						$(this).data('value') +
						'">'
				);
			}
		});

		$('.facetwp-checkbox').on('keypress', function () {
			$(this).trigger('click');
		});

		$('.search-icon-wrap').find('i').hide();
	});

	// fallback
	if ('undefined' !== typeof FWP) {
		if (FWP.loaded) {
			$('.facetwp-checkbox').each(function () {
				if ($(this).find('label').length === 0) {
					$(this).wrapInner('<label></label>');
				}
			});
		}
	}

	//Menu focus management and Esc key
	var $offCanvas = $('.off-canvas');
	var $mainPageContentContainers = $('body > main, body > footer')
		.not('.off-canvas')
		.not('.js-off-canvas-overlay');

	function setPageContentInert(isMenuOpen) {
		$mainPageContentContainers.attr('aria-hidden', isMenuOpen ? 'true' : 'false');
		var $focusableElementsOutsideMenu = $mainPageContentContainers.find(
			'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details, [tabindex]:not([tabindex="-1"])'
		);

		$focusableElementsOutsideMenu.each(function () {
			if (isMenuOpen) {
				var currentTabindex = $(this).attr('tabindex');
				$(this).attr('data-original-tabindex', currentTabindex !== undefined ? currentTabindex : 'none');
				$(this).attr('tabindex', '-1');
			} else {
				var originalTabindex = $(this).attr('data-original-tabindex');
				if (originalTabindex === 'none') {
					$(this).removeAttr('tabindex');
				} else if (originalTabindex !== undefined) {
					$(this).attr('tabindex', originalTabindex);
				}
				$(this).removeAttr('data-original-tabindex');
			}
		});
	}

	var $focusableInMenu, $firstFocusableInMenu, $lastFocusableInMenu;
	$offCanvas.on('opened.zf.offcanvas', function () {
		setPageContentInert(true);

		$focusableInMenu = $(this)
			.find(
				'header a[href], header button:not([disabled]), header input:not([disabled]), header textarea:not([disabled]), header select:not([disabled]), header details, header [tabindex]:not([tabindex="-1"])'
			)
			.filter(':visible');

		if ($focusableInMenu.length > 0) {
			$firstFocusableInMenu = $focusableInMenu.first();
			$lastFocusableInMenu = $focusableInMenu.last();

			$firstFocusableInMenu.focus(); // Focus on the first element in the menu

			// Trap focus within the menu
			$lastFocusableInMenu.on('keydown.trapFocus', function (e) {
				if (e.key === 'Tab' && !e.shiftKey) {
					e.preventDefault();
					$firstFocusableInMenu.focus();
				}
			});

			$firstFocusableInMenu.on('keydown.trapFocus', function (e) {
				if (e.key === 'Tab' && e.shiftKey) {
					e.preventDefault();
					$lastFocusableInMenu.focus();
				}
			});
		}
	});

	$offCanvas.on('closed.zf.offcanvas', function () {
		setPageContentInert(false);
		if ($firstFocusableInMenu) $firstFocusableInMenu.off('keydown.trapFocus');
		if ($lastFocusableInMenu) $lastFocusableInMenu.off('keydown.trapFocus');
		// Foundation should ideally return focus to the menu toggle.
	});

	// Close menu with Esc key
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $offCanvas.hasClass('is-open') && $offCanvas.is(':visible')) {
			$offCanvas.foundation('close');
		}
	});

	// On click of .off-canvas .close-button, focus on .menu-icon
	$(document).on('click', '.off-canvas .close-button', function () {
		var $menuIcon = $('.menu-icon');
		if ($menuIcon.length) {
			$menuIcon.focus();
		}
	});

	// Optional: Close search with Esc & return focus
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $searchBar.is(':visible')) {
			$searchToggle.trigger('click');
			$searchToggle.focus();
		}
	});

	// wcag 1.4.13 Content with hover or focus (AA)
	// toggle functionality for submenu parent hover
	$(document).on('keydown', function (event) {
		if (event.key === 'Escape' || event.key === 'Esc') {

			$('.menu-item-has-children:has(.js-dropdown-active)').each(function () {
				$(this).find('>ul').removeClass('js-dropdown-active');
			});

			$('.menu-item-has-children > ul:hover').each(function () {
				$(this).removeClass('js-dropdown-active');
			});
		}
	});
});
